import { FC } from 'react';
import useOnScroll from '@/menu/hooks/useOnScroll';

const OnScrollPage: FC = () => {
    useOnScroll();
    return null;
};

export default OnScrollPage;
